import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAkgI3M2LvSsJr3hFhxpnKVE727h5qNJ3E",
  authDomain: "gannigames.com",
  projectId: "world-cup-challenge-b477b",
  storageBucket: "world-cup-challenge-b477b.firebasestorage.app",
  messagingSenderId: "1024928962091",
  appId: "1:1024928962091:web:1e8e28685890534b85fc6e"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
